module.exports = __webpack_public_path__ + "img/tu3.25f25c6e.png";